module.exports = {"screenSize":{"width":1200,"height":639},"maxScreenSize":{"width":1600,"height":852},"hotspotSize":{"width":34,"height":34},"defaultScene":"agent","baseFontSize":16}


//////////////////
// WEBPACK FOOTER
// ./src/data/global.json
// module id = 77
// module chunks = 0